package org.multiplatform.kotfolio.pages

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.core.Page

@Page("ktorfit")
@Composable
fun APICallingKtorFitPage() {
    BlogLayout(
        PageProperties(
            "Ktorfit",
            "Ktorfit is an HTTP client/Kotlin Symbol Processor for Kotlin Multiplatform (Android, iOS, Js, Jvm, Linux)"
        ),
        BlogProperties("Kotlin Multiplatform", "Ktorfit")
    )
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            KotlinCode(
                code = $$"""
                    [versions]
                    agp = "8.7.3"
                    android-compileSdk = "35"
                    android-minSdk = "24"
                    android-targetSdk = "35"
                    androidx-activity = "1.10.1"
                    androidx-appcompat = "1.7.0"
                    androidx-constraintlayout = "2.2.1"
                    androidx-core = "1.16.0"
                    androidx-espresso = "3.6.1"
                    androidx-lifecycle = "2.9.0"
                    androidx-testExt = "1.2.1"
                    composeHotReload = "1.0.0-alpha10"
                    composeMultiplatform = "1.8.1"
                    datastorePreferences = "1.1.7"
                    junit = "4.13.2"
                    koinVersion = "4.0.4"
                    kotlin = "2.1.21"
                    kotlinx-coroutines = "1.10.2"
                    kotlinxSerializationJson = "1.8.1"
                    ktorClientVersion = "3.1.3"
                    ktorfit = "2.5.2"
                    voyagerVersion = "1.1.0-beta03"
                    kspVersion = "2.1.21-2.0.1"
                    collapsingTopBarCompose = "1.2.6"

                    [libraries]
                    androidx-datastore-preferences = { module = "androidx.datastore:datastore-preferences", version.ref = "datastorePreferences" }
                    koin-android = { module = "io.insert-koin:koin-android", version.ref = "koinVersion" }
                    koin-core = { module = "io.insert-koin:koin-core", version.ref = "koinVersion" }
                    kotlin-test = { module = "org.jetbrains.kotlin:kotlin-test", version.ref = "kotlin" }
                    kotlin-testJunit = { module = "org.jetbrains.kotlin:kotlin-test-junit", version.ref = "kotlin" }
                    junit = { module = "junit:junit", version.ref = "junit" }
                    androidx-core-ktx = { module = "androidx.core:core-ktx", version.ref = "androidx-core" }
                    androidx-testExt-junit = { module = "androidx.test.ext:junit", version.ref = "androidx-testExt" }
                    androidx-espresso-core = { module = "androidx.test.espresso:espresso-core", version.ref = "androidx-espresso" }
                    androidx-appcompat = { module = "androidx.appcompat:appcompat", version.ref = "androidx-appcompat" }
                    androidx-constraintlayout = { module = "androidx.constraintlayout:constraintlayout", version.ref = "androidx-constraintlayout" }
                    androidx-activity-compose = { module = "androidx.activity:activity-compose", version.ref = "androidx-activity" }
                    androidx-lifecycle-viewmodel = { module = "org.jetbrains.androidx.lifecycle:lifecycle-viewmodel", version.ref = "androidx-lifecycle" }
                    androidx-lifecycle-runtimeCompose = { module = "org.jetbrains.androidx.lifecycle:lifecycle-runtime-compose", version.ref = "androidx-lifecycle" }
                    kotlinx-coroutinesSwing = { module = "org.jetbrains.kotlinx:kotlinx-coroutines-swing", version.ref = "kotlinx-coroutines" }
                    kotlinx-serialization-json = { module = "org.jetbrains.kotlinx:kotlinx-serialization-json", version.ref = "kotlinxSerializationJson" }
                    ktor-client-content-negotiation = { module = "io.ktor:ktor-client-content-negotiation", version.ref = "ktorClientVersion" }
                    ktor-client-logging = { module = "io.ktor:ktor-client-logging", version.ref = "ktorClientVersion" }
                    ktor-serialization-kotlinx-json = { module = "io.ktor:ktor-serialization-kotlinx-json", version.ref = "ktorClientVersion" }
                    ktorfit-lib = { module = "de.jensklingenberg.ktorfit:ktorfit-lib", version.ref = "ktorfit" }
                    voyager-bottom-sheet-navigator = { module = "cafe.adriel.voyager:voyager-bottom-sheet-navigator", version.ref = "voyagerVersion" }
                    voyager-koin = { module = "cafe.adriel.voyager:voyager-koin", version.ref = "voyagerVersion" }
                    voyager-navigator = { module = "cafe.adriel.voyager:voyager-navigator", version.ref = "voyagerVersion" }
                    voyager-screenmodel = { module = "cafe.adriel.voyager:voyager-screenmodel", version.ref = "voyagerVersion" }
                    voyager-tab-navigator = { module = "cafe.adriel.voyager:voyager-tab-navigator", version.ref = "voyagerVersion" }
                    voyager-transitions = { module = "cafe.adriel.voyager:voyager-transitions", version.ref = "voyagerVersion" }
                    collapsing-top-bar-compose = { module = "com.github.germainkevinbusiness:CollapsingTopBarCompose", version.ref = "collapsingTopBarCompose" }

                    [plugins]
                    androidApplication = { id = "com.android.application", version.ref = "agp" }
                    androidLibrary = { id = "com.android.library", version.ref = "agp" }
                    composeHotReload = { id = "org.jetbrains.compose.hot-reload", version.ref = "composeHotReload" }
                    composeMultiplatform = { id = "org.jetbrains.compose", version.ref = "composeMultiplatform" }
                    composeCompiler = { id = "org.jetbrains.kotlin.plugin.compose", version.ref = "kotlin" }
                    kotlinMultiplatform = { id = "org.jetbrains.kotlin.multiplatform", version.ref = "kotlin" }
                    ktorfitPlugin = { id = "de.jensklingenberg.ktorfit", version.ref = "ktorfit" }
                    kotlinSerialization = { id = "org.jetbrains.kotlin.plugin.serialization", version.ref = "kotlin" }
                    #ksp = { id = "com.google.devtools.ksp", version.ref = "kspVersion" }
                    
                    import org.jetbrains.compose.desktop.application.dsl.TargetFormat
                    import org.jetbrains.kotlin.gradle.ExperimentalKotlinGradlePluginApi
                    import org.jetbrains.kotlin.gradle.dsl.JvmTarget

                    plugins {
                        alias(libs.plugins.kotlinMultiplatform)
                        alias(libs.plugins.androidApplication)
                        alias(libs.plugins.composeMultiplatform)
                        alias(libs.plugins.composeCompiler)
                        alias(libs.plugins.composeHotReload)

                        alias(libs.plugins.kotlinSerialization)
                        id("com.google.devtools.ksp")
                        alias(libs.plugins.ktorfitPlugin)
                        id("org.jetbrains.kotlinx.atomicfu") version "0.27.0"
                        //alias(libs.plugins.ksp)

                    }

                    kotlin {
                        androidTarget {
                            @OptIn(ExperimentalKotlinGradlePluginApi::class)
                            compilerOptions {
                                jvmTarget.set(JvmTarget.JVM_11)
                            }
                        }

                        listOf(
                            iosX64(),
                            iosArm64(),
                            iosSimulatorArm64()
                        ).forEach { iosTarget ->
                            iosTarget.binaries.framework {
                                baseName = "ComposeApp"
                                isStatic = true
                            }
                        }

                        jvm("desktop")

                        sourceSets {

                            val desktopMain by getting
                            val coilVersion = "3.2.0"
                            val ktorVersion = "3.1.3"

                            androidMain.dependencies {
                                implementation(compose.preview)
                                implementation(libs.androidx.activity.compose)
                                implementation(libs.koin.android)
                                implementation("io.ktor:ktor-client-android:${ktorVersion}")
                            }
                            appleMain.dependencies {
                                implementation("io.ktor:ktor-client-darwin:${ktorVersion}")
                            }
                            desktopMain.dependencies {
                                implementation(compose.desktop.currentOs)
                                implementation(libs.kotlinx.coroutinesSwing)
                                implementation("io.ktor:ktor-client-java:${ktorVersion}")
                            }
                            commonMain.dependencies {
                                implementation(compose.runtime)
                                implementation(compose.foundation)
                                implementation(compose.material3)
                                implementation(compose.materialIconsExtended)
                                implementation(compose.ui)
                                implementation(compose.components.resources)
                                implementation(compose.components.uiToolingPreview)
                                implementation(libs.androidx.lifecycle.viewmodel)
                                implementation(libs.androidx.lifecycle.runtimeCompose)

                                implementation(libs.kotlinx.serialization.json)

                                // Navigator
                                implementation(libs.voyager.navigator)
                                // Screen Model
                                implementation(libs.voyager.screenmodel)
                                // BottomSheetNavigator
                                implementation(libs.voyager.bottom.sheet.navigator)
                                // TabNavigator
                                implementation(libs.voyager.tab.navigator)
                                // Transitions
                                implementation(libs.voyager.transitions)
                                // Koin integration
                                implementation(libs.voyager.koin)

                                // DataStore
                                implementation(libs.androidx.datastore.preferences)

                                //koin
                                implementation(libs.koin.core)

                                //ktorfit
                                implementation(libs.ktorfit.lib)

                                //ktor
                                implementation(libs.ktor.client.logging)
                                implementation(libs.ktor.client.content.negotiation)
                                implementation(libs.ktor.serialization.kotlinx.json)

                                //implementation(libs.collapsing.top.bar.compose)


                                implementation("io.coil-kt.coil3:coil-compose:${coilVersion}")
                                implementation("io.coil-kt.coil3:coil-network-ktor3:${coilVersion}")
                            }
                            commonTest.dependencies {
                                implementation(libs.kotlin.test)
                            }
                        }
                    }

                    android {
                        namespace = "com.sundayting.wancmp"
                        compileSdk = libs.versions.android.compileSdk.get().toInt()

                        defaultConfig {
                            applicationId = "com.sundayting.wancmp"
                            minSdk = libs.versions.android.minSdk.get().toInt()
                            targetSdk = libs.versions.android.targetSdk.get().toInt()
                            versionCode = 1
                            versionName = "1.0"
                        }
                        packaging {
                            resources {
                                excludes += "/META-INF/{AL2.0,LGPL2.1}"
                            }
                        }
                        buildTypes {
                            getByName("release") {
                                isMinifyEnabled = false
                            }
                        }
                        compileOptions {
                            sourceCompatibility = JavaVersion.VERSION_11
                            targetCompatibility = JavaVersion.VERSION_11
                        }
                    }

                    dependencies {
                        debugImplementation(compose.uiTooling)
                    }

                    compose.desktop {
                        application {
                            mainClass = "com.sundayting.wancmp.MainKt"

                            nativeDistributions {
                                targetFormats(TargetFormat.Dmg, TargetFormat.Msi, TargetFormat.Deb)
                                packageName = "com.sundayting.wancmp"
                                packageVersion = "1.0.0"
                            }
                        }
                    }
                    """.trimIndent()
            )

            //https://github.com/yang961226/WanCmp.git
            KotlinCode(
                code = """
                    fun initKoin(config: KoinAppDeclaration? = null) {
                        startKoin {
                            includes(config)
                            modules(
                                ktorfitModule,
                                networkModule
                            )
                        }
                    }
                    
                    val ktorfitModule = module {
                        single {
                            val wanConverterFactory = get<WanConverterFactory>(named("WanConverterFactory"))
                            ktorfit {
                                baseUrl("")
                                converterFactories(wanConverterFactory)
                                httpClient(get<HttpClient>())
                            }
                        }
                        single(named("WanConverterFactory")) {
                            WanConverterFactory()
                        }
                        single<CookiesStorage> {
                            DataStoreCookieJar()
                        }
                        single<HttpClient> {
                            HttpClient {
                                install(Logging) {
                                    logger = object : Logger {
                                        override fun log(message: String) {
                                            level = LogLevel.ALL
                                        }
                                    }
                                }
                                install(ContentNegotiation) {
                                    json(Json {
                                        isLenient = true
                                        ignoreUnknownKeys = true
                                        explicitNulls = false
                                    })
                                }
                                install(HttpCookies) {
                                    storage = get()
                                }
                            }
                        }
                    }

                    val networkModule = module {
                        single<ArticleService> {
                            get<Ktorfit>().createArticleService()
                        }
                    }
                    
                    interface ArticleService {
                        @GET("banner/json/")
                        suspend fun fetchBanner(): NResult<BannerBeanResultBean>
                    }
                    
                    sealed class NResult<T> {
                        data class Success<T>(val body: T) : NResult<T>()
                        class Error(val ex: Throwable) : NResult<Nothing>()
                    }

                    @OptIn(ExperimentalContracts::class)
                    fun <T> NResult<T>.isSuccess(): Boolean {
                        contract {
                            returns(true) implies (this@isSuccess is NResult.Success)
                            returns(false) implies (this@isSuccess is NResult.Error)
                        }
                        return this is NResult.Success
                    }
                    """.trimIndent()
            )

            //https://medium.com/@mariorobertofortunato/using-kotlin-contracts-to-improve-type-safety-with-sealed-results-195115c9c666
            KotlinCode(
                code = """
                    sealed class Result<out T> {
                        object Loading : Result<Nothing>()
                        data class Success<T>(val data: T) : Result<T>()
                        data class Failure(val errorMessage: String?) : Result<Nothing>()
                    }
                    
                    @OptIn(ExperimentalContracts::class)
                    fun <T> Result<T>.isSuccess(): Boolean {
                        contract {
                            returns(true) implies (this@isSuccess is Result.Success<T>)
                        }
                        return this is Result.Success<T>
                    }
                    
                    @OptIn(ExperimentalContracts::class)
                    fun <T> Result<T>.isFailure(): Boolean {
                        contract {
                            returns(true) implies (this@isFailure is Result.Failure)
                        }
                        return this is Result.Failure
                    }

                    @OptIn(ExperimentalContracts::class)
                    fun <T> Result<T>.isLoading(): Boolean {
                        contract {
                            returns(true) implies (this@isLoading is Result.Loading)
                        }
                        return this is Result.Loading
                    }
                    
                    //Result Success
                    if (result is Result.Success) {
                        val success = result as Result.Success
                        showUser(success.data)
                    }
                    """.trimIndent()
            )
        }
    }
}

/*
        single<String>(qualifier = org.koin.core.qualifier.named("baseUrl")) {
            getProperty("API_BASE_URL", "https://activehive.pt:443")
        }
*/

//https://www.dhiwise.com/post/how-to-implement-kotlin-contracts-in-your-code-step-by-step
//https://github.com/kotlin-flex/ktorfitx
//https://github.com/vincenzosarnataro/UsersKMP.git (Koin Annotations, KTOR with K-RETROFIT, KTOR custom header)
//https://github.com/dalafiarisamuel/Unsplash-KMP.git (Ktorfit, KtorDsl, Platform (Mobile/Desktop) Download Image)
//https://github.com/RznNike/DemoKMP.git (Good API Calling (webSocketManager, ktorfit, Common UseCase, Common ViewModel), Cache Manage)
//https://github.com/mrcsxsiq/KMP-Kitchen-Connect (Good API Calling)
//https://github.com/AgelousisDev/FoodNutrition